import queryString from "query-string";
import { ThunkDispatch } from "redux-thunk";

import createApiModule from "@/redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@/redux/store.types";
import { Config } from "@/utils/config.utils";

import { getDiscriminator } from "./preferredStore.discriminators";
import PreferredStoreReducer from "./preferredStore.reducer";
import {
    $PreferredStoreModuleName,
    TGetPreferredStoreByCodeRequest
} from "./preferredStore.types";

const { actions } = createApiModule(
    $PreferredStoreModuleName,
    ({ url }) => `${url}`,
    {
        reducer: PreferredStoreReducer
    }
);

export const getPreferredStoreByCode =
    (
        { code, strategy, sku }: TGetPreferredStoreByCodeRequest,
        force: boolean = false
    ) =>
    (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        const fullParams = {
            includeProductAvailability: !!sku,
            sku: sku
        };

        return dispatch(
            actions.load(
                {
                    path: {
                        url: `/storeservice/${Config.general.basestore}/localized/stores/${
                            code
                        }?${queryString.stringify(fullParams)}`
                    }
                },
                "GET",
                force,
                {
                    discriminator: getDiscriminator({
                        strategy: strategy,
                        sku: sku
                    })
                }
            )
        );
    };

export const clear = actions.clear;
export const refetch = actions.refetch;
